import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { configureStore } from "@reduxjs/toolkit";
import App from './App';
import reportWebVitals from './reportWebVitals';
import themeReducer from './store/slices/themeSlice';
import compareReducer from './store/slices/compareSlice';
import { Provider } from 'react-redux';
import 'antd/dist/reset.css';
import "./i18n";
import { HelmetProvider } from 'react-helmet-async';

// 🔥 GOOGLE LOGIN
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById('root'));

const store = configureStore({
  reducer: {
    theme: themeReducer,
    compare: compareReducer,
  },
});

root.render(
  <React.StrictMode>

    <HelmetProvider>
      {/* 🔥 GOOGLE PROVIDER */}
      <GoogleOAuthProvider clientId="152653612853-i28mmv5da6sl4mbeu0uiibnuruiol6ip.apps.googleusercontent.com">

        <Provider store={store}>
          <App />
        </Provider>

      </GoogleOAuthProvider>
    </HelmetProvider>

  </React.StrictMode>
);

reportWebVitals();